export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-previous-43e7d4c2a1acbbdcde00d02fb99eb465.svg";